(() => {
  // This adapter targets the smith-camile-and-stone Upnova template only.
  const bundleId = window.location.pathname.match(/\/pages\/bundle-builder\/(1594|1711|1712)\/?$/)?.[1];
  if (!bundleId) return;
  const instanceKey = `__camileBundleLimit${bundleId}`;
  if (window[instanceKey]) return;
  window[instanceKey] = true;

  const configuredLimit = Number(document.getElementById('cs-bundle-limit-script')?.dataset.maxItems);
  const defaultLimit = bundleId === '1712' ? 3 : 5;
  const LIMIT = Number.isSafeInteger(configuredLimit) && configuredLimit > 0 ? configuredLimit : defaultLimit;
  const HOST = 'upnova-widget[model="bundle-builder"][name="smith-camile-and-stone"]';
  const LIST = '[part~="summary-container"] [part~="upnova-selected-list-rows"]';
  const ITEM = '[part~="upnova-selected-list-row"] [part~="upnova-619fcca72dc7"]';
  const ADD = [
    'button[part~="upnova-smith-card-cta"]',
    '[part~="upnova-product-modal-content"] button[part~="upnova-a55676e8bd4d"]',
    'button[part~="upnova-aba1cb9e5619"]'
  ].join(',');
  const SUBMIT = 'button[part~="upnova-summary-button"]';
  const BLOCKED = 'data-cs-bundle-limit-blocked';
  let controller;
  let waitingForShadow;

  function mount(root) {
    const marked = new Map();
    const notices = new Map();
    let pending = false;
    let frame;
    let stopped = false;
    const style = document.createElement('style');
    style.textContent = `
      [${BLOCKED}] { opacity: .45 !important; cursor: not-allowed !important; }
      .cs-bundle-limit-status { margin: .5rem 0 0; font: inherit; font-size: 14px; line-height: 1.4; color: inherit; }
    `;
    root.append(style);

    function quantity() {
      // The desktop summary remains mounted on mobile. Count it once, excluding
      // placeholders and the duplicated mobile modal. Each row is one unit,
      // even when several rows share the same product/variant.
      const list = root.querySelector(LIST);
      return list ? list.querySelectorAll(ITEM).length : null;
    }

    function unblock(button) {
      if (!marked.has(button)) return;
      const previous = marked.get(button);
      if (button.getAttribute('aria-disabled') === 'true') {
        if (previous === null) button.removeAttribute('aria-disabled');
        else button.setAttribute('aria-disabled', previous);
      }
      button.removeAttribute(BLOCKED);
      marked.delete(button);
    }

    function block(button, blocked) {
      if (!blocked) return unblock(button);
      if (!marked.has(button)) marked.set(button, button.getAttribute('aria-disabled'));
      if (!button.hasAttribute(BLOCKED)) button.setAttribute(BLOCKED, '');
      if (button.getAttribute('aria-disabled') !== 'true') button.setAttribute('aria-disabled', 'true');
      // Leave native disabled alone: React owns sold-out/loading states. Capture
      // interception below enforces our additional aria-disabled restriction.
    }

    function update() {
      if (stopped) return;
      // React's first render can clear nodes inserted while its root was empty.
      if (!root.contains(style)) root.append(style);
      const count = quantity();
      for (const button of marked.keys()) {
        if (!root.contains(button)) unblock(button);
      }
      root.querySelectorAll(ADD).forEach(button => block(button, count === null || count >= LIMIT || pending));
      root.querySelectorAll(SUBMIT).forEach(button => {
        block(button, count !== LIMIT || pending);
        let notice = notices.get(button);
        if (!notice || !root.contains(notice)) {
          notice = document.createElement('p');
          notice.className = 'cs-bundle-limit-status';
          notice.setAttribute('role', 'status');
          notice.setAttribute('aria-live', 'polite');
          button.after(notice);
          notices.set(button, notice);
        }
        const message = count === null ? 'Bundle is loading. Please try again shortly.'
          : count > LIMIT ? `Please remove ${count - LIMIT} item${count - LIMIT === 1 ? '' : 's'} to complete your ${LIMIT}-piece bundle.`
          : count === LIMIT ? `${LIMIT} of ${LIMIT} selected. Remove an item to change your selection.`
          : `${count} of ${LIMIT} selected. Choose ${LIMIT - count} more item${LIMIT - count === 1 ? '' : 's'}.`;
        if (notice.textContent !== message) notice.textContent = message;
      });
      for (const [button, notice] of notices) {
        if (!root.contains(button)) {
          notice.remove();
          notices.delete(button);
        }
      }
    }

    function guard(event) {
      const button = event.composedPath().find(node => node instanceof Element && node.matches(`${ADD},${SUBMIT}`));
      if (!button || !root.contains(button)) return;
      const count = quantity();
      const invalid = button.matches(SUBMIT) ? count !== LIMIT : count === null || count >= LIMIT;
      const appAriaDisabled = marked.has(button) ? marked.get(button) : button.getAttribute('aria-disabled');
      if (invalid || pending || button.disabled || appAriaDisabled === 'true') {
        event.preventDefault();
        event.stopImmediatePropagation();
        update();
        return;
      }
      // Reserve this interaction until React has rendered. Prevent a second
      // rapid click from using the same pre-render quantity. Native keyboard
      // activation also dispatches click and follows this path.
      pending = true;
      frame = requestAnimationFrame(() => {
        pending = false;
        update();
      });
    }

    root.addEventListener('click', guard, true);
    const observer = new MutationObserver(update);
    observer.observe(root, { childList: true, subtree: true, attributes: true, attributeFilter: ['disabled', 'part'] });
    update();
    return {
      root,
      stop() {
        stopped = true;
        observer.disconnect();
        root.removeEventListener('click', guard, true);
        cancelAnimationFrame(frame);
        for (const button of marked.keys()) unblock(button);
        for (const notice of notices.values()) notice.remove();
        style.remove();
      }
    };
  }

  function connect() {
    const host = document.querySelector(HOST);
    const root = host?.shadowRoot;
    if (controller && controller.root !== root) {
      controller.stop();
      controller = undefined;
    }
    if (root && !controller) controller = mount(root);
    // Attaching a shadow root does not produce a document mutation. Poll only
    // while waiting for it; observe normal app renders and theme-editor swaps.
    if (host && !root && !waitingForShadow) waitingForShadow = setInterval(connect, 250);
    if ((!host || root) && waitingForShadow) {
      clearInterval(waitingForShadow);
      waitingForShadow = undefined;
    }
  }

  new MutationObserver(connect).observe(document.documentElement, { childList: true, subtree: true });
  connect();
})();
